<template>
    <div>
        <form @submit.prevent="submit">
            <div class="alert alert-danger" v-if="form.error">
                {{ trans('booking-process.find-booking.cannot_find') }}
            </div>

            <validated-input
                v-model="form.bookingReference"
                :label-text="trans('post_hire.booking_reference_label')"
                name="bookingReference"
                type="text"
                :placeholder="trans('post_hire.booking_reference_label')"
                rules="required"
                form-type="vertical"
                :columns="12"
                :formatted-name="trans('post_hire.booking_reference_label')"
            ></validated-input>

            <validated-input
                v-model="form.lastName"
                :label-text="trans('booking-process.payment.last_name_placeholder')"
                name="lastName"
                type="text"
                :placeholder="trans('booking-process.payment.last_name_placeholder')"
                rules="required"
                form-type="vertical"
                :columns="12"
                :formatted-name="trans('booking-process.payment.last_name_label')"
            ></validated-input>

            <gm-button class="regular-button" type="next" @click="submit" :busy="form.busy" :disabled="form.disabled">{{ trans('booking-process.search_additional.search') }} </gm-button>
        </form>
    </div>
</template>

<script>
import lang from '../../shared/mixins/lang';
import accounting from 'greenmotion-shared/mixins/accounting';
import GmButton from 'greenmotion-shared/Components/shared/Button';
import ValidatedInput from '../../shared/components/validation/Input.vue';

export default {
    mixins: [lang, accounting],
    components: {
        GmButton,
        ValidatedInput,
    },
    data() {
        return {
            authenticated: window.greenmotion.authenticated,
            form: {
                busy: false,
                bookingReference: null,
                lastName: null,
                error: false,
            },
        };
    },
    methods: {
        async submit() {
            let fields = [await this.$validator.validate('bookingReference'), await this.$validator.validate('lastName')];

            const validateFields = Promise.all(fields);

            const isValidFields = (await validateFields).every((isValid) => isValid);

            if (isValidFields) {
                this.form.busy = true;

                if (this.form.bookingReference === null || this.form.lastName === null) {
                    return;
                }

                this.$store
                    .dispatch('postFindBooking', { formData: this.form })
                    .then((response) => {
                        const bookingReference = response?.data?.booking_reference;
                        const hasUser = response?.data?.has_user;

                        this.form.busy = false;
                        this.form.success = true;
                        this.form.error = false;

                        if (this.authenticated && hasUser) {
                            window.parent.location.href = `/user/bookings/${bookingReference}`;
                        } else {
                            top.location = `/guest/bookings/${bookingReference}`;
                        }
                    })
                    .catch((error) => {
                        this.form.busy = false;
                        this.form.success = false;
                        this.form.error = true;
                    });
            }
        },
    },
};
</script>

<style>
.gm-prefix-icon {
    background: transparent;
    border: 2px solid #eeeeee;
    color: #484848;
    border-right: none !important;
}
.gm-prefix-input {
    border-left: none !important;
}
</style>
